import PropTypes from 'prop-types';
import React from 'react';
import { NoValue } from '~/modules/common/components';
import { RoleScheduleWithTooltip } from '~/modules/common/components/User';

export const RoleColumn = ({ record: resourceList }) => {
  const roleScheduleAsOfDate = resourceList.roleSchedulesAsOfDate;

  const showRoleSchedule = roleScheduleAsOfDate?.effectiveRoleSchedule;

  return showRoleSchedule ? (
    <RoleScheduleWithTooltip
      roleScheduleAsOfDate={roleScheduleAsOfDate.effectiveRoleSchedule}
      showEffectiveDate
    />
  ) : (
    <NoValue />
  );
};

RoleColumn.propTypes = {
  record: PropTypes.object.isRequired
};

export default RoleColumn;
